import { alpha } from "@mui/material";

const palette = {
  coral: "#EB6E5E",
  darkBlue: "#1D395B",
  sand: "#FEF9F0",
  brightBlue: "#236CFF",
  aqua: "#33D3C3",
  lightBlue: "#C2F2ED",
  subtleGrey: alpha("#000000", 0.13),
  translucentWhite: alpha("#FFFFFF", 0.5),
  grey: "#666666",
  red: "#ad0000",
};

export default palette;
